export const ALL_PARTICIPATIONS = "all-participations";
export const SINGLE_PARTICIPATION = "single-participations";
export const ALL_CONFIGURATIONS = "all-configurations";
export const PARTICIPATION_SUMMARY = "participation-summary";
